import React from "react";

const FeaturesSection = () => {
  const features = [
    {
      id: "features-tab-1",
      title: "Dashboard",
      icon: "bi-speedometer2",
      iconColor: "#0dcaf0",
      image: "features-1.svg",
      description:
        "Your all-in-one control center, tailored for every user role. Get quick access to key information and actions that matter to you.",
      points: [
        "Admin: View institution metrics, manage modules, and track performance",
        "Teacher: Manage classes, assignments, attendance, and student progress",
        "Student/Parent: Check schedules, grades, homework, and updates",
      ],
      mainText:
        "Our dynamic dashboards provide personalized views for admins, teachers, students, and parents. Whether it’s monitoring performance, staying updated on tasks, or tracking progress — everything is just a click away, making management simple and efficient.",
    },
    {
      id: "features-tab-2",
      title: "Smart Management",
      icon: "bi-box-seam",
      iconColor: "#6610f2",
      image: "features-2.svg",
      description:
        "Manage your institution easily with our powerful website and mobile app — built for convenience anytime, anywhere.",
      points: [
        "Accessible on web and app — manage on the go or from your desk",
        "User-friendly interface — simple, clean design for smooth navigation",
        "Custom layouts — choose what works best for your team",
      ],
      mainText:
        "EduAdminHub gives you the freedom to manage your school or college from both our website and mobile app. With fl exible layouts like mini view, RTL support, and dark mode, you can work comfortably no matter where you are. Our platform adapts to your needs — so you can focus on what matters most.",
    },
    {
      id: "features-tab-3",
      title: "People",
      icon: "bi-people-fill",
      iconColor: "#20c997",
      image: "features-3.svg",
      description:
        "Easily manage everyone connected to your institution in one place.",
      points: [
        "Students: Store profi les with personal details, academics, attendance, and more",
        "Parents: Keep contact info, payment history, and linked student records",
        "Teachers: Manage subjects, schedules, and performance data",
      ],
      mainText:
        "EduAdminHub helps you handle students, parents, and teachers through a single platform. From registrations to records, everything stays organized and easy to access — so you can focus on what matters most: education.",
    },
    {
      id: "features-tab-4",
      title: "Academics",
      icon: "bi-journal-bookmark",
      iconColor: "#df1529",
      image: "features-4.svg",
      description:
        "Streamline and automate all key academic operations with ease.",
      points: [
        "Manage classes, sections, and subjects effortlessly",
        "Create and update timetables, routines, and syllabus",
        "Simplify homework, exams, and result management",
      ],
      mainText:
        "EduAdminHub’s academic module helps schools and colleges organize everything from class structures and room allocations to exam schedules and grading — all in one place. It ensures smooth operations, saves time, and keeps your academic activities well-coordinated.",
    },
    {
      id: "features-tab-5",
      title: "HRM",
      icon: "bi-person-badge",
      iconColor: "#0d6efd",
      image: "features-5.svg",
      description:
        "Simplify and streamline staff management for your institution.",
      points: [
        "Manage staff records — Store and access personal details, qualifi cations, and roles",
        "Track attendance & leaves — Monitor attendance, handle leave requests, and view balances",
        "Automate payroll — Calculate salaries with deductions, overtime, and leave adjustments",
      ],
      mainText:
        "Our HR Management module makes it easy to handle staff records, organize departments, defi ne designations, manage attendance and leaves, publish holiday calendars, and automate payroll — all in one platform for smooth and efficient operations.",
    },
    {
      id: "features-tab-6",
      title: "Notifications",
      icon: "bi-bell-fill",
      iconColor: "#fd7e14",
      image: "features-6.svg",
      description: "Keep everyone updated with important news and alerts.",
      points: [
        "Notice Board: Share exam dates, events, holidays, and more.",
        "Events: Plan, schedule, and track all school activities.",
        "Email Alerts: Send updates on homework, timetables, leave requests, and more.",
      ],
      mainText:
        "Stay connected with 25+ automated email notifications. EduAdminHub keeps students, staff, and parents informed — from registration updates and homework alerts to timetables, library records, leave requests, and more. Communication made easy, all in one place.",
    },
  ];

  return (
    <section id="features" className="features section font-[poppins]">
      <div className="container" data-aos="fade-up">
        <ul className="nav nav-tabs row gy-4 d-flex">
          {features.map((feature, index) => (
            <li key={feature.id} className="nav-item col-6 col-md-4 col-lg-2">
              <div
                className={`nav-link ${index === 0 ? "active show" : ""}`}
                data-bs-toggle="tab"
                data-bs-target={`#${feature.id}`}
              >
                <i
                  className={`bi ${feature.icon}`}
                  style={{ color: feature.iconColor }}
                ></i>
                <h4 className="font-[poppins] text-center text-[16px]">
                  {feature.title}
                </h4>
              </div>
            </li>
          ))}
        </ul>
        <div className="tab-content">
          {features.map((feature, index) => (
            <div
              key={feature.id}
              className={`tab-pane fade ${index === 0 ? "active show" : ""}`}
              id={feature.id}
            >
              <div className="row gy-4">
                <div
                  className="col-lg-8 order-2 order-lg-1"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <h3 className="font-[Playfair] ml-1 italic text-[#9bd66c]">
                    {feature.title}
                  </h3>
                  <div className=" w-14 h-1 bg-[#9bd66c] mb-2"></div>

                  <p className="fst-italic">{feature.description}</p>
                  <ul>
                    {feature.points.map((point, pointIndex) => (
                      <li key={pointIndex}>
                        <i className="bi bi-check-circle-fill"></i> {point}
                      </li>
                    ))}
                  </ul>
                  <p>{feature.mainText}</p>
                </div>
                <div
                  className="col-lg-4 order-1 order-lg-2 text-center"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <img
                    src={`assets/img/${feature.image}`}
                    alt=""
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
